import './globals';
import 'bootstrap';
import React from 'react';
import { render } from 'react-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import Loader from 'react-loaders';
import App from './containers/App';
import store, { persistor } from './store/config';
import './theme/styles.scss';

render(
  <Provider store={store}>
    <PersistGate persistor={persistor} loading={
      // @ts-expect-error -- preserve this legacy loader without required type-only props
      <Loader />
    }>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById('app'),
);
